import {
	CloseButton,
	Elements,
	ExpandingSection,
	ReportTable,
} from '@tfo/common'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import { RouteComponentProps, withRouter } from 'react-router'
import { useHistory } from 'react-router-dom'
import RootStore from '../../../../stores/RootStore'
import './Faq.scss'

const { Paragraph } = Elements

export interface IFaqProps {
	rootStore?: RootStore
}

const Faq = (
	props: React.FunctionComponent &
		IFaqProps &
		WrappedComponentProps &
		RouteComponentProps,
) => {
	const { intl } = props
	const history = useHistory()

	return (
		<React.Fragment>
			<div className="LoginCustomerOverlay">
				<div className="Faq">
					<div className="Faq__Header">
						<h1>{intl.formatMessage({ id: 'faq.container.heading' })}</h1>
						<CloseButton
							className="Faq__Header__Close"
							onClick={() => history.goBack()}
						/>
					</div>
					<div className="Faq__Body">
						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({ id: 'faq.title.whatInformation' })}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({ id: 'faq.paragraph.whatInformation' })}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({ id: 'faq.title.howLongTime' })}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({ id: 'faq.paragraph.howLongTime' })}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.howLongRaportAvailable',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.howLongRaportAvailable',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.individualSeeRaport',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.individualSeeRaport',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.individualWithdrawApproval',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.individualWithdrawApproval',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.individualWrongInformation',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.individualWrongInformation',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.howToUnderstandRaport',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.howToUnderstandRaport1',
									})}
									<br />
									<br />
									{intl.formatMessage({
										id: 'faq.paragraph.howToUnderstandRaport2',
									})}
									<br />
									<br />
									{intl.formatMessage({
										id: 'faq.paragraph.howToUnderstandRaport3',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>
					</div>
					<hr />
					<div className="Faq__Footer">
						<h1>
							{' '}
							{intl.formatMessage({ id: 'faq.footer.heading.cannot.find' })}
						</h1>
						<Paragraph>
							{' '}
							{intl.formatMessage({ id: 'faq.footer.paragraph.info' })}{' '}
							<a href="">
								{' '}
								{intl.formatMessage({
									id: 'faq.footer.paragraph.customer.email',
								})}
							</a>.
						</Paragraph>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}

export default withRouter(inject('rootStore')(injectIntl(observer(Faq))))
